import { useParams } from "react-router-dom";
import RiskAssessmentCard from "../../../../../shared/ui/RiskScoreCard/RiskAssessmentCard";
import { getTenantRiskFactors } from "../../../../../shared/services/apis";
import { useEffect, useState } from "react";
import RiskSkeleton from "../../../../../shared/ui/RiskScoreCard/RiskSkeleton";

// Weight mapping function
const getWeightForTask = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();

  if (taskLower.includes("macro risk")) return "10%";
  if (taskLower.includes("gdp growth") && taskLower.includes("% p.a"))
    return "10%";
  if (taskLower.includes("employment growth") && taskLower.includes("% p.a"))
    return "10%";
  if (taskLower.includes("population growth") && taskLower.includes("% p.a"))
    return "20%";
  if (taskLower.includes("wage inflation") && taskLower.includes("% p.a"))
    return "20%";
  if (
    taskLower.includes("student enrolment growth") &&
    taskLower.includes("% p.a")
  )
    return "10%";
  if (taskLower.includes("sector concentration")) return "20%";

  return "0%";
};

interface Props {
  RiskFactorId: string;
}

export default function MarketPositionCard({ RiskFactorId }: Props) {
  const [selectedSubRiskId, setSelectedSubRiskId] = useState<string>("");
  const { tenantId } = useParams<{ tenantId: string }>();
  const [subRiskFactor, setSubRiskFactor] = useState<any[]>([]);
  const [riskPerimeters, setRiskPerimeters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshRiskScorecard = async () => {
      try {
        setLoading(true);
        console.log(tenantId, "it is in riskscroeooo");
        const response = await getTenantRiskFactors(tenantId || "");
        const riskFactors = response.data || response;
        console.log(riskFactors, "it is in market position");

        const selectedRiskFactor = riskFactors.find(
          (factor: any) => factor.id === RiskFactorId
        );

        if (selectedRiskFactor) {
          const subFactors = selectedRiskFactor.subRiskFactors.map((sub: any) => ({
            id: sub.id,
            name: sub.name,
            tenantId: sub.tenantRiskFactorId,
            weight: sub.weight,
          }));
          
          setSubRiskFactor(subFactors);
          
          // Set default selection to first sub-risk factor
          if (subFactors.length > 0 && !selectedSubRiskId) {
            setSelectedSubRiskId(subFactors[0].id);
          }
          
       const defaultSubRiskId =
            subFactors.length > 0 ? subFactors[0].id : "";
          if (!selectedSubRiskId) setSelectedSubRiskId(defaultSubRiskId);

          // Set risk perimeters based on currently selected sub-risk factor
          const currentSubRiskId = selectedSubRiskId || defaultSubRiskId;
          setRiskPerimeters(
            selectedRiskFactor.factorGroups
              .filter(
                (group: any) =>
                  group.riskFactorId === RiskFactorId &&
                  group.subRiskFactorId === currentSubRiskId
              )
              .flatMap(
                (group: any) =>
                  group.result?.ratings?.map((rating: any) => ({
                    task: rating.task, // from ratings
                    rating: rating.rating, // from ratings
                    reasoning: rating.reasoning, // from ratings
                    subRiskFactorId: group.subRiskFactorId, // keep sub-risk factor reference
                  })) || []
              )
          );
        } else {
          setSubRiskFactor([]);
          setRiskPerimeters([]);
        }

        console.log(subRiskFactor, "sub Facuturrdsssss");
        console.log(riskPerimeters, "risk parameters");
      } catch (error) {
        console.error("Failed to fetch risk factors:", error);
      } finally {
        setLoading(false);
      }
    };

    refreshRiskScorecard();
  }, [tenantId, RiskFactorId, selectedSubRiskId]);

  useEffect(() => {
    console.log(riskPerimeters, "freee use effect");
  }, [subRiskFactor, riskPerimeters]);

  // Filter risk parameters by selected sub-risk factor
  const filteredRiskPerimeters = {
    ratings: riskPerimeters
      .filter((param) => param.subRiskFactorId === selectedSubRiskId)
      .map((param) => ({
        task: param.task,
        rating: param.rating,
        reasoning: param.reasoning,
        weight:param.weightPercentage
      })),
  };

  // Show loading state
  if (loading) {
    return <RiskSkeleton/>;
  }

  // Don't render until we have data
  if (subRiskFactor.length === 0) {
    return <div>No risk data available</div>;
  }

  return (
    <div>
     
        {selectedSubRiskId && (
      <div className=" px-4">
        {/* Dynamic Category Switcher – now inside the same div */}
       {/* {subRiskFactor.length > 1 && (
  <div className="flex justify-center space-x-2">
    {subRiskFactor.map((subFactor) => (
      <button
        key={subFactor.id}
        className={`px-3 py-1 text-sm font-light rounded-2xl border cursor-pointer transition-colors duration-200 ${
          selectedSubRiskId === subFactor.id
            ? "bg-gray-50 text-gray-700 border-gray-300"
            : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
        }`}
        onClick={() => setSelectedSubRiskId(subFactor.id)}
      >
        {subFactor.name}
      </button>
    ))}
  </div>
)} */}

      
    
        {/* RiskAssessmentCard */}
        <RiskAssessmentCard
          title={` ${
            subRiskFactor.find((sub) => sub.id === selectedSubRiskId)?.name ||
            "Market Position "
          }`}
          apiResponse={filteredRiskPerimeters}
          getWeightForTask={getWeightForTask}
        />
      </div>
    )}
    </div>
  );
}